import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ApplicationService } from 'app/application/application.service';
import { TokenService } from 'app/token/token.service';
import { getJourneyTypeFromJourneyVersion } from 'app/token/token';

@Injectable()
export class DashboardResolveService implements Resolve<any> {
    constructor(private applicationService: ApplicationService, private tokenService: TokenService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return new Promise((resolve, reject) => {
            const mConfig = this.tokenService.getMerchantConfig();
            const merchantId = mConfig ? mConfig.merchantId : '';
            const application = this.applicationService.getApplication();
            if (!application) {
                this.applicationService.getFlowType(merchantId).subscribe((flow) => {
                    if (flow.isCJMAllowed) {
                        this.applicationService.createAndGetCJMJourney(merchantId).subscribe((journey) => {
                            this.tokenService.setJourneyFlowType(getJourneyTypeFromJourneyVersion(journey.journeyVersion));
                            if (journey.isCompleted) {
                                this.tokenService.setCJMFlag(false);
                                resolve('journey complete');
                            } else {
                                this.tokenService.setJourney(journey);
                                this.tokenService.setCJMFlag(true);
                                resolve('journey not complete');
                            }
                        }, error => resolve('initiate API error'));
                    } else {
                        resolve('not allowed');
                    }


                }, error => resolve('journey allowed API error'));
            } else {
                resolve(null);
            }
        });
    }
}
